import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FormularioComponent } from './formulario/formulario.component';

const APP_ROUTES: Routes = [
        { path: '', component: FormularioComponent },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(APP_ROUTES);


// WEBPACK FOOTER //
// D:/contracheque-inativos/src/app/app.routing.ts